import { Injectable } from "@angular/core";
import { BackendService } from "../backend/backend.service";

@Injectable({
  providedIn: "root"
})
export class UploadSurveyService {

  constructor(private backendService: BackendService) {}

  
}
